module.exports = "/_next/static/images/CustomSources-f5d67b315736ebf8589b6b30d33da702.webp";